import React, { createContext, useEffect, useState } from "react";
import {
  SafeAreaView,
  Text,
  View,
  Button,
  Image,
  ActivityIndicator,
} from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import HomeStackNavigator from "./navigators/HomeStackNavigator";
import { NativeWindStyleSheet } from "nativewind";
import "react-native-gesture-handler";

import * as WebBrowser from "expo-web-browser";
import * as Google from "expo-auth-session/providers/google";
import {
  getAuth,
  getIdToken,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithCredential,
  signOut,
} from "firebase/auth";
import { sessionData, app, getUserFullName } from "./utils/firebase";
import LoginComponent from "./components/LoginComponent";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { privacyPolicyText } from "./utils/privacyPolicy";
// import * as SystemUI from "expo-system-ui";

// export const AuthContext = createContext({
// 	loginState: "loading",
// 	setLoginState: () => {},
// });

WebBrowser.maybeCompleteAuthSession();

export default function App() {
  NativeWindStyleSheet.setOutput({
    default: "native",
  });
  // SystemUI.setBackgroundColorAsync("black");

  const [request, response, promptAsync] = Google.useIdTokenAuthRequest({
    clientId:
      // "799625096612-c03at3hho8qktbpmoe29l2mhug1562a1.apps.googleusercontent.com", // Android
      // "799625096612-0fl8i5l7b77p30oed3dqs1vc94jd2ock.apps.googleusercontent.com", // Web
      // "799625096612-kam0rdp5f1o978orq349ljrudrp00t54.apps.googleusercontent.com", // Android App
      "951688417196-4d8ue5ht69trb132inamk9ru0emj1idh.apps.googleusercontent.com", // Web release
    // "951688417196-760fsejpfh7olfkdbhdn21f3l0defqi5.apps.googleusercontent.com" // Android release
  });

  useEffect(() => {
    if (response?.type === "success") {
      const { id_token } = response.params;
      const auth = getAuth(app);
      const credential = GoogleAuthProvider.credential(id_token);
      signInWithCredential(auth, credential);
    }
  }, [response]);

  onAuthStateChanged(getAuth(app), async (user) => {
    if (user) {
      setLoginState("loggedIn");
      const idToken = await getIdToken(user);
      sessionData.idToken = idToken;
    } else {
      setLoginState("notLoggedIn");
    }
  });

  const [loginState, setLoginState] = useState("loading");
  const Stack = createNativeStackNavigator();
  const linking = {
    prefixes: [],
    config: {
      screens: {
        Home: "home",
        PrivacyPolicy: "privacy-policy",
      },
    },
  };

  function PrivacyPolicyComponent() {
    return (
      <SafeAreaView className="bg-white items-center justify-center px-2 py-2">
        <View className="flex-1 items-center justify-center">
          <Text>{privacyPolicyText}</Text>
        </View>
      </SafeAreaView>
    );
  }

  function HomeComponent() {
    if (loginState === "loading") {
      return (
        <SafeAreaView className=" bg-[#263238] flex-1 items-center justify-center">
          <View className="flex-1 items-center justify-center">
            <ActivityIndicator size={"large"} color="white" />
          </View>
        </SafeAreaView>
      );
    }
    if (loginState === "notLoggedIn") {
      return (
        <SafeAreaView className="flex-1 bg-[#263238]">
          <View className="flex-1 px-2 justify-center w-full max-w-screen-lg mx-auto">
            <LoginComponent promptAsync={promptAsync} />
          </View>
        </SafeAreaView>
      );
    }
    if (loginState === "loggedIn") {
      return (
        // <AuthContext.Provider value={{ loginState, setLoginState }}>
        <NavigationContainer independent={true}>
          <HomeStackNavigator />
        </NavigationContainer>
        // </AuthContext.Provider>
      );
    }
    return <></>;
  }

  return (
    // <AuthContext.Provider value={{ loginState, setLoginState }}>
    <NavigationContainer linking={linking}>
      <Stack.Navigator
        screenOptions={{
          headerShown: false,
        }}
      >
        <Stack.Screen name="Home" component={HomeComponent} />
        <Stack.Screen name="PrivacyPolicy" component={PrivacyPolicyComponent} />
      </Stack.Navigator>
    </NavigationContainer>
    // </AuthContext.Provider>
  );
}
